'use client';
import { Component, ReactNode } from 'react';
import KdState from '@/components/shell/KdState';

interface Props { children: ReactNode; fallback?: ReactNode }
interface State { hasError: boolean; error?: Error }

function isNextControlError(error: any): boolean {
  // notFound() / redirect() throw special errors with a digest like
  // "NEXT_NOT_FOUND", "NEXT_REDIRECT;...", "NEXT_HTTP_ERROR_FALLBACK;404".
  // These must propagate to the framework so the proper 404/redirect status fires —
  // otherwise this boundary swallows them and the page returns 200 (soft 404).
  return typeof error?.digest === 'string' && error.digest.startsWith('NEXT_');
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError(error: Error) {
    if (isNextControlError(error)) throw error;
    return { hasError: true, error };
  }
  componentDidCatch(error: Error) {
    if (isNextControlError(error)) throw error;
    console.error('ErrorBoundary:', error);
  }
  render() {
    // VX L4-10 — 기본 폴백 = KdState 'error' 판. error.message 는 그리지 않는다(내부 문구 노출 방지).
    if (this.state.hasError) return this.props.fallback ?? (
      <div className="kd-st-wrap">
        <KdState
          kind="error"
          kicker="일시 오류"
          title="이 영역을 그리지 못했습니다"
          hint="「다시 시도」를 누르면 이 영역만 다시 그립니다. 계속 안 되면 페이지를 새로 고쳐 주세요."
          actions={[{ label: '다시 시도', onClick: () => this.setState({ hasError: false }), primary: true }]}
        />
      </div>
    );
    return this.props.children;
  }
}
